module.exports = "/_next/static/images/14afeb2fed73f6b9b99cfd121ac75505-nubanker-ds@3x.jpg.webp";